import { useAtom } from 'jotai';
import { searchAtom } from '~/atoms/search';
export const useSearch = () => {
    return useAtom(searchAtom);
};
